import krogerLogo from "/img/integration/kroger.png"
import { ConnectLogo } from "../connect-logo"
import { Form } from "@/components/form/Form.tsx"
import { useFormState } from "@/components/form/form_state.tsx"
import { Input, PasswordInput } from "@/components/form/Input.tsx"
import { Button } from "@/components/ui/button.tsx"
import { useState } from "preact/compat"
import { useLocation } from "wouter-preact"
import { use_connect_redirect_to } from "../use_connect_redirect_to"
import { CenterColumnContainer } from "@/components/LoginScreen.tsx"
import { upsertIntegration } from "@/api/integration"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectKrogerPage(props: any = {}) {
  const redirectTo = use_connect_redirect_to(props.redirectTo)
  const [, setLocation] = useLocation()
  const [loading, setLoading] = useState(false)

  const form = useFormState({
    username: "",
    password: "",
  })

  async function onSubmit() {
    setLoading(true)
    form.set_form_errors([])
    const res = await upsertIntegration("kroger", form.username.value, { password: form.password.value })
    setLoading(false)
    if (!res.ok) {
      form.set_form_errors(["Kroger login failed. Please try again."])
      return
    }
    setLocation(redirectTo)
  }

  return (
    <CenterColumnContainer>
      <Form class="space-y-6" onSubmit={onSubmit} alerts={form.form_alerts}>
        <ConnectLogo src={krogerLogo} alt="Kroger" />
        <p class="text-gray-500 text-sm">Enter your Kroger credentials to sync your deduction data.</p>
        <Input label="Username" type="text" name="username" required={true} bind={form.username} noAutofill />
        <PasswordInput label="Password" required={true} bind={form.password} noAutofill />
        <div class="flex justify-end">
          <Button
            type="submit"
            class="bg-gray-900 text-white rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 disabled:bg-gray-300 disabled:cursor-not-allowed"
            disabled={loading}>
            {loading ? "Connecting..." : "Connect Account"}
          </Button>
        </div>
      </Form>
    </CenterColumnContainer>
  )
}
